import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import OfflineIcon from '../components/shared/icon/OfflineIcon';
import { useBanner } from '../contexts/BannerContext';

export const useOnlineStatusCheck = () => {
  const banners = useBanner();
  const { t } = useTranslation('common');

  const [offlineWarningBannerId, setOfflineWarningBannerId] = useState<string | null>(null);

  const onOnlineStatusChanged = useCallback(() => {
    const isOnline = window.navigator.onLine;

    if (isOnline) {
      if (offlineWarningBannerId) {
        banners.removeBanner(offlineWarningBannerId);
        setOfflineWarningBannerId(null);
      }
    } else {
      if (offlineWarningBannerId) return; // somehow already showing

      const id = banners.showBanner({
        icon: <OfflineIcon className="h-5 w-5" />,
        message: t('bad-connection.offline'),
      });
      setOfflineWarningBannerId(id);
    }
  }, [offlineWarningBannerId, banners, t]);

  useEffect(() => {
    window.addEventListener('online', onOnlineStatusChanged);
    window.addEventListener('offline', onOnlineStatusChanged);

    return () => {
      window.removeEventListener('online', onOnlineStatusChanged);
      window.removeEventListener('offline', onOnlineStatusChanged);
    };
  }, [onOnlineStatusChanged]);
};
